/**
 * Kunduzgi / tungi rejim.
 * - ThemeToggle: ikki holatli tugma (ochiq sahifalar: ariza formasi, carrier portali). Quyosh va oy aylanib almashadi.
 * - AppearanceSwitcher: uch holatli segment (Light / Dark / Auto) -- ilova ichida profil menyusida (redesign v2).
 * Butun ekran almashishi -- features/theme/theme.ts (qiya parda bo'lib kirib keladi).
 */
import { Moon, MonitorSmartphone, Sun } from "lucide-react";
import { useTranslation } from "react-i18next";
import { cn } from "@/lib/utils";
import { setPreference, setTheme, useTheme, useThemePreference, type ThemePreference } from "@/features/theme/theme";
import { Segmented } from "@/components/ui/segmented";

export function ThemeToggle({ className }: { className?: string }) {
  const { t } = useTranslation();
  const theme = useTheme();
  const next = theme === "dark" ? "light" : "dark";
  const label = t(`theme.${next}`);
  return (
    <button
      type="button"
      onClick={() => setTheme(next)}
      aria-label={label}
      title={label}
      className={cn("relative grid h-9 w-9 place-items-center rounded-full bg-fill text-ink-soft transition-colors hover:bg-fill-hover hover:text-ink", className)}
    >
      <Sun
        size={16}
        strokeWidth={1.75}
        aria-hidden
        className={cn("absolute transition-all duration-500 ease-out motion-reduce:transition-none", theme === "dark" ? "rotate-0 scale-100 opacity-100" : "-rotate-90 scale-0 opacity-0")}
      />
      <Moon
        size={16}
        strokeWidth={1.75}
        aria-hidden
        className={cn("absolute transition-all duration-500 ease-out motion-reduce:transition-none", theme === "dark" ? "rotate-90 scale-0 opacity-0" : "rotate-0 scale-100 opacity-100")}
      />
    </button>
  );
}

export function AppearanceSwitcher({ className, fullWidth }: { className?: string; fullWidth?: boolean }) {
  const { t } = useTranslation();
  const pref = useThemePreference();
  return (
    <Segmented<ThemePreference>
      ariaLabel={t("appearance.title")}
      size="sm"
      className={className}
      fullWidth={fullWidth}
      value={pref}
      onChange={setPreference}
      options={[
        { value: "light", label: t("appearance.light"), icon: Sun },
        { value: "dark", label: t("appearance.dark"), icon: Moon },
        { value: "system", label: t("appearance.system"), icon: MonitorSmartphone },
      ]}
    />
  );
}
